// extracted by mini-css-extract-plugin
module.exports = {"tintImage":"cart_tintImage__Yh_Nc"};